import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'

// import Editor from '@/views/article/Edit'

Vue.use(Router)

const baseRoutes = [{
  path: '/',
  name: 'Login',
  component: resolve => require(['@/views/auth/Login'], resolve),
  meta: {
    noAuth: true, // 添加该字段，表示进入这个路由是不需要登录的
    title: '登录',
    isMenu: true
  }
}]

export const routes = [{
  path: '/main',
  component: resolve => require(['@/views/Layout'], resolve),
  name: 'Main',
  redirect: '/main/home',
  meta: {
    title: '小易云',
    isMenu: true
  },
  children: [
    ///////////// Home
    {
      path: '/main/home',
      component: resolve => require(['@/views/home/Index'], resolve),
      name: 'Home',
      meta: {
        title: '监控平台',
        isMenu: false
      }
    },
    /////// Setting /////////////////////////////////////////////////////
    {
      path: '/main/admin',
      component: resolve => require(['@/views/admin/List'], resolve),
      name: 'adminList',
      meta: {
        title: '管理员',
        isMenu: true
      }
    },
    {
      path: '/main/user',
      component: resolve => require(['@/views/user/List'], resolve),
      name: 'User',
      meta: {
        title: '用户管理',
        isMenu: true
      }
    },
    {
      path: '/main/userInfo',
      component: resolve => require(['@/views/user/List'], resolve),
      name: 'UserList',
      meta: {
        title: '用户信息',
        isMenu: true
      }
    },
    {
      path: '/main/user/setting/:userId',
      component: resolve => require(['@/views/user/Setting'], resolve),
      name: 'UserList',
      meta: {
        title: '用户设置',
        isMenu: true
      }
    },
    {
      path: '/main/stock/newly',
      component: resolve => require(['@/views/stock/Edit'], resolve),
      name: 'newly',
      meta: {
        title: '新增设备',
        isMenu: true
      }
    },
    {
      path: '/main/admin/setting/:userId?',
      name: 'adminSetting',
      component: resolve => require(['@/views/admin/Setting'], resolve),
      meta: {
        title: '资料设置',
        isMenu: false
      }
    },
    {
      path: '/main/menu',
      name: 'Menu',
      component: resolve => require(['@/views/menu'], resolve),
      meta: {
        title: '资源配置',
        isMenu: true
      }
    },
    /////// Device //////////////////////////////////////////////////
    {
      path: '/main/deviceManage',
      component: resolve => require(['@/views/device/List'], resolve),
      name: 'DeviceManage',
      meta: {
        title: '设备管理',
        isMenu: true
      }
    },
    {
      path: '/main/device',
      component: resolve => require(['@/views/device/List'], resolve),
      name: 'Device',
      meta: {
        title: '设备列表',
        isMenu: true
      }
    },
    {
      path: '/main/device/edit/:devId?',
      component: resolve => require(['@/views/device/Edit'], resolve),
      name: 'DeviceEdit',
      meta: {
        title: '设备编辑',
        isMenu: false
      }
    },
    // {
    //   path: '/main/device/type',
    //   component: resolve => require(['@/views/devType/List'], resolve),
    //   name: 'DevTypeList',
    //   meta: {
    //     title: '设备类别',
    //     isMenu: true
    //   },
    // },
    // {
    //   path: '/main/device/plugin',
    //   component: resolve => require(['@/views/devPlugin/List'], resolve),
    //   name: 'DevPlugin',
    //   meta: {
    //     title: '设备插件',
    //     isMenu: true
    //   },
    // },
    // {
    //   path: '/main/factory/deviceModel',
    //   name: 'DeviceModel',
    //   component: resolve => require(['@/views/deviceModel/List'], resolve),
    //   meta: {
    //     title: '设备型号',
    //     isMenu: true
    //   }
    // },
    {
      path: '/main/device/foundation',
      component: resolve => require(['@/views/device/foundation'], resolve),
      name: 'DevTypeList',
      meta: {
        title: '基础设定',
        isMenu: true
      }
    },
    {
      path: '/main/device/arg',
      component: resolve => require(['@/views/devArg/List'], resolve),
      name: 'DevArgList',
      meta: {
        title: '设备参数',
        isMenu: true
      }
    },
    {
      path: '/main/device/monitor',
      component: resolve => require(['@/views/device/Monitor'], resolve),
      name: 'DevMonitor',
      meta: {
        title: '设备监控',
        isMenu: true
      }
    },
    {
      path: '/main/device/energy',
      component: resolve => require(['@/views/device/Energy'], resolve),
      name: 'DevEnergy',
      meta: {
        title: '设备能耗',
        isMenu: true
      }
    },
    //////// Client /////////////////////////////////////////////////
    {
      path: '/main/auth/client',
      component: resolve => require(['@/views/auth/client/List'], resolve),
      name: 'ClientList',
      meta: {
        title: '应用列表',
        isMenu: true
      }
    },
    {
      path: '/main/auth/client/edit:id?',
      component: resolve => require(['@/views/auth/client/Edit'], resolve),
      name: 'ClientEdit',
      meta: {
        title: '客户端编辑',
        isMenu: false
      }
    },
    {
      path: '/main/auth/role',
      component: resolve => require(['@/views/auth/Role'], resolve),
      name: 'Role',
      meta: {
        title: '角色管理',
        isMenu: true
      }
    },
    {
      path: '/main/auth/permission',
      component: resolve => require(['@/views/auth/Permission'], resolve),
      name: 'Permission',
      meta: {
        title: '权限配置',
        isMenu: false
      }
    },
    //////// Article ////////////////////////////////////////////////////////
    {
      path: '/main/archivesManagement',
      component: resolve => require(['@/views/article/List'], resolve),
      name: 'Article',
      meta: {
        title: '档案管理',
        isMenu: true
      }
    },
    {
      path: '/main/article/edit',
      component: resolve => require(['@/views/article/Edit'], resolve),
      name: 'ArticleEdit',
      meta: {
        title: '文章编辑',
        isMenu: false
      }
    },
    {
      path: '/main/article',
      component: resolve => require(['@/views/article/List'], resolve),
      name: 'Article',
      meta: {
        title: '文章管理',
        isMenu: true
      }
    },
    {
      path: '/main/charge',
      name: 'Charge',
      component: resolve => require(['@/views/charge/List'], resolve),
      meta: {
        title: '云易快充系统',
        isMenu: true
      }
    },
    {
      path: '/main/banners',
      name: 'Banner',
      component: resolve => require(['@/views/charge/List'], resolve),
      meta: {
        title: '云易banner',
        isMenu: true
      }
    },
    {
      path: '/main/recharges',
      name: 'BannerRecharges',
      component: resolve => require(['@/views/charge/recharges'], resolve),
      meta: {
        title: '充值列表',
        isMenu: true
      }
    },
    {
      path: '/main/rechargeBill',
      name: 'RechargeBill',
      component: resolve => require(['@/views/charge/rechargeBill'], resolve),
      meta: {
        title: '充值账单',
        isMenu: true
      }
    },
    {
      path: '/main/chargeSocket',
      name: 'ChargeSocket',
      component: resolve => require(['@/views/charge/chargeSocket'], resolve),
      meta: {
        title: '充电插座'
        // isMenu: true
      }
    },
    {
      path: '/main/chargeStation',
      name: 'ChargeStation',
      component: resolve =>
        require(['@/views/charge/chargeStation'], resolve),
      meta: {
        title: '充电站信息',
        isMenu: true
      }
    },
    {
      path: '/main/electricityRate',
      name: 'ElectricityRate',
      component: resolve =>
        require(['@/views/charge/electricityRate'], resolve),
      meta: {
        title: '充电费率表',
        isMenu: true
      }
    },
    {
      path: '/main/chargeBill',
      name: 'ChargeBill',
      component: resolve => require(['@/views/charge/chargeBill'], resolve),
      meta: {
        title: '充电订单',
        isMenu: true
      }
    },
    {
      path: '/main/franchisee',
      name: 'Franchisee',
      component: resolve => require(['@/views/charge/franchisee'], resolve),
      meta: {
        title: '加盟商信息',
        isMenu: true
      }
    },
    {
      path: '/main/paymentBill',
      name: 'PaymentBill',
      component: resolve => require(['@/views/charge/paymentBill'], resolve),
      meta: {
        title: '加盟商结算表',
        isMenu: true
      }
    },
    {
      path: '/main/franchiseeEdit/:id?',
      name: 'FranchiseeEdit',
      component: resolve =>
        require(['@/views/charge/franchiseeEdit'], resolve),
      meta: {
        title: '加盟商编辑',
        isMenu: false
      }
    },
    {
      path: '/main/userCollect',
      name: 'userCollent',
      component: resolve => require(['@/views/charge/userCollect'], resolve),
      meta: {
        title: '用户数据汇总',
        isMenu: true
      }
    },
    {
      path: '/main/franchiseeMember',
      name: 'FranchiseeMember',
      component: resolve =>
        require(['@/views/charge/franchiseeMember'], resolve),
      meta: {
        title: '成员'
        // isMenu: true
      }
    },
    {
      path: '/main/charge/control',
      name: 'Control',
      component: resolve => require(['@/views/charge/control'], resolve),
      meta: {
        title: '控制面板',
        isMenu: true
      }
    },
    ////////// Factory /////////////////////////////////////////////////////////
    {
      path: '/main/factory',
      name: 'Factory',
      // component:
      meta: {
        title: '生产管理',
        isMenu: true
      }
    },
    {
      path: '/main/factory/firmware',
      name: 'Firmware',
      component: resolve => require(['@/views/factory/firmware'], resolve),
      meta: {
        title: '固件升级',
        isMenu: true
      }
    },
    {
      path: '/main/factory/code',
      name: 'DeviceCode',
      component: resolve => require(['@/views/factory/DeviceCode'], resolve),
      meta: {
        title: '设备编码',
        isMenu: true
      }
    },
    ////////// Stock /////////////////////////////////////////////////////////
    {
      path: '/main/stock',
      name: 'Stock',
      component: resolve => require(['@/views/stock/index'], resolve),
      meta: {
        title: '库存管理',
        isMenu: true
      }
    },
    ////////////////////// ammeter ///////////////////////////////////////////////////
    {
      path: '/main/energy/root',
      name: 'EnergyRoot',
      component: resolve => require(['@/views/energy/root'], resolve),
      meta: {
        title: '能源管理系统'
      }
    },
    {
      path: '/main/energy/clientRoot/:clientId',
      name: 'ClientRoot',
      component: resolve => require(['@/views/energy/clientRoot'], resolve),
      meta: {
        title: '能源管理系统 / 应用管理'
      }
    },
    {
      path: '/main/energy/energyDeviceManager',
      name: 'EnergyDeviceManager',
      component: resolve =>
        require(['@/views/energy/energyDeviceManager'], resolve),
      meta: {
        title: '设备管理'
      }
    },
    {
      path: '/main/energy/stationRoot/:stationId?/:stationName?',
      name: 'StationRoot',
      component: resolve => require(['@/views/energy/stationRoot'], resolve),
      meta: {
        title: '能源管理系统 / 应用管理 / 站点管理'
      }
    },
    {
      path: '/main/energy/energyMeterDevice/:clientId?/:stationId?/:typeId?/:deviceStatus?/:title?/:id?',
      name: 'EnergyMeterDevice',
      component: resolve =>
        require(['@/views/energy/energyMeterDevice'], resolve),
      meta: {
        title: '能源管理系统 / 设备管理'
      }
    },
    {
      path: '/main/energy',
      name: 'Ammeter',
      component: resolve => require(['@/views/energy/energyMeter'], resolve),
      meta: {
        title: '能源管理系统'
      }
    },
    {
      path: '/main/energy/energyBill',
      name: 'EnergyBill',
      component: resolve => require(['@/views/energy/energyBill'], resolve),
      meta: {
        title: '交易明细'
      }
    },
    {
      path: '/main/energy/energyBillDetail',
      name: 'EnergyBillDetail',
      component: resolve =>
        require(['@/views/energy/energyBillDetail'], resolve),
      meta: {
        title: '账单明细'
      }
    },
    {
      path: '/main/energy/waterBillDetail',
      name: 'WaterBillDetail',
      component: resolve =>
        require(['@/views/energy/waterBillDetail'], resolve),
      meta: {
        title: '账单明细'
      }
    },
    {
      path: '/main/energy/energyReport',
      name: 'EnergyReport',
      component: resolve => require(['@/views/energy/energyReport'], resolve),
      meta: {
        title: '交易汇总'
      }
    },
    {
      path: '/main/energy/energyMeter',
      name: 'EnergyMeter',
      component: resolve => require(['@/views/energy/energyMeter'], resolve),
      meta: {
        title: '设备管理'
      }
    },
    {
      path: '/main/energy/energyRate',
      name: 'EnergyRate',
      component: resolve => require(['@/views/energy/energyRate'], resolve),
      meta: {
        title: '消费费率'
      }
    },
    {
      path: '/main/energy/permission/:id?',
      name: 'EnergyPermission',
      component: resolve => require(['@/views/energy/permission'], resolve),
      meta: {
        title: '权限管理'
      }
    },
    {
      path: '/main/energy/region',
      name: 'Region',
      component: resolve => require(['@/views/energy/region'], resolve),
      meta: {
        title: '区域管理'
      }
    },
    {
      path: '/main/energy/schedule',
      name: 'Schedule',
      component: resolve => require(['@/views/energy/schedule'], resolve),
      meta: {
        title: '定时表'
      }
    },
    {
      path: '/main/auth/log',
      component: resolve => require(['@/views/auth/Log'], resolve),
      name: 'Log',
      meta: {
        title: '日志查询',
        isMenu: true
      }
    },
    {
      path: '/main/chargeRoot',
      name: 'ChargeRoot',
      component: resolve => require(['@/views/charge/chargeRoot'], resolve),
      meta: {
        title: '充电站信息'
      }
    },
    ////////////////////// ammeter ///////////////////////////////////////////////////
    {
      path: '/main/energy/waterBill',
      name: 'WaterBill',
      component: resolve => require(['@/views/energy/waterBill'], resolve),
      meta: {
        title: '水表交易明细'
      }
    },
    {
      path: '/main/energy/generalStatement',
      name: 'GeneralStatement',
      component: resolve =>
        require(['@/views/energy/generalStatement'], resolve),
      meta: {
        title: '系统总报表'
      }
    },
    {
      path: '/main/energy/waterReport',
      name: 'WaterReport',
      component: resolve => require(['@/views/energy/waterReport'], resolve),
      meta: {
        title: '水表交易明细'
      }
    },
    {
      path: '/main/energy/unit/:stationName?',
      name: 'Unit',
      component: resolve => require(['@/views/energy/unit'], resolve),
      meta: {
        title: '单位管理'
      }
    },
    ////////////////////// consume ///////////////////////////////////////////////////
    {
      path: '/main/consume/consumeRoot',
      name: 'ConsumeRoot',
      component: resolve => require(['@/views/consume/consumeRoot'], resolve),
      meta: {
        title: '消费系统'
      }
    },
    {
      path: '/main/consume/stationEdit/:stationId',
      name: 'ConsumeStationEdit',
      component: resolve => require(['@/views/consume/stationEdit'], resolve),
      meta: {
        title: '站点概览'
      }
    },
    {
      path: '/main/consume/rechargeCardPrice',
      name: 'RechargeCardPrice',
      component: resolve =>
        require(['@/views/consume/rechargeCardPrice'], resolve),
      meta: {
        title: '充值表'
      }
    },
    {
      path: '/main/consume/card',
      name: 'Card',
      component: resolve => require(['@/views/consume/card'], resolve),
      meta: {
        title: '卡表'
      }
    },
    {
      path: '/main/consume/cardType/',
      name: 'ConsumeCardType',
      component: resolve => require(['@/views/consume/cardType'], resolve),
      meta: {
        title: '卡类'
      }
    },
    {
      path: '/main/consume/consumeAdmin',
      name: 'ConsumeAdmin',
      component: resolve =>
        require(['@/views/consume/consumeAdmin'], resolve),
      meta: {
        title: '管理员表'
      }
    },
    {
      path: '/main/consume/clearingBill',
      name: 'ClearingBill',
      component: resolve =>
        require(['@/views/consume/clearingBill'], resolve),
      meta: {
        title: '结算记录'
      }
    },
    {
      path: '/main/consume/consumeRate',
      name: 'ConsumeRate',
      component: resolve => require(['@/views/consume/consumeRate'], resolve),
      meta: {
        title: '消费费率'
      }
    },
    {
      path: '/main/consume/rechargeCardBill',
      name: 'RechargeCardBill',
      component: resolve =>
        require(['@/views/consume/rechargeCardBill'], resolve),
      meta: {
        title: '充值记录'
      }
    },
    {
      path: '/main/consume/station',
      name: 'Station',
      component: resolve => require(['@/views/consume/station'], resolve),
      meta: {
        title: '站点管理'
      }
    },
    {
      path: '/main/consume/root',
      name: 'Consume',
      component: resolve => require(['@/views/consume/root'], resolve),
      meta: {
        title: '消费系统',
        isMenu: true
      }
    },
    {
      path: '/main/consume/consumeBill',
      name: 'ConsumeBill',
      component: resolve => require(['@/views/consume/consumeBill'], resolve),
      meta: {
        title: '结算记录'
      }
    },
    {
      path: '/main/consume/consumeDevice',
      name: 'ConsumeDevice',
      component: resolve =>
        require(['@/views/consume/consumeDevice'], resolve),
      meta: {
        title: '设备'
      }
    },
    {
      path: '/main/consume/consumeBillDevice/:date&:clientId',
      name: 'ConsumeBillDevice',
      component: resolve =>
        require(['@/views/consume/consumeBillDevice'], resolve),
      meta: {
        title: '结算记录'
      }
    },
    {
      path: '/main/consume/consumeBillDetail/:consumeDeviceId&:startDate&:endDate',
      name: 'ConsumeBillDetail',
      component: resolve =>
        require(['@/views/consume/consumeBillDetail'], resolve),
      meta: {
        title: '结算记录'
      }
    },
    {
      path: '/main/consume/deviceManager',
      name: 'ConsumeDeviceManager',
      component: resolve =>
        require(['@/views/consume/deviceManager'], resolve),
      meta: {
        title: '设备管理'
      }
    },
    ////////////////////// rent ///////////////////////////////////////////////////
    {
      path: '/main/rent/controll',
      name: 'Controll',
      component: resolve => require(['@/views/rent/controll'], resolve),
      meta: {
        title: '租房管理系统'
      }
    },
    {
      path: '/main/rent/rentAdmin',
      name: 'RentAdmin',
      component: resolve => require(['@/views/rent/rentAdmin'], resolve),
      meta: {
        title: '管理员列表'
      }
    },

    ////////////////////// oneCard ///////////////////////////////////////////////////
    {
      path: '/main/oneCard/access/setting',
      name: 'Setting',
      component: resolve =>
        require(['@/views/oneCard/access/setting'], resolve),
      meta: {
        title: '基础设置'
      }
    },
    {
      path: '/main/oneCard/access/rule',
      name: 'Rule',
      component: resolve => require(['@/views/oneCard/access/rule'], resolve),
      meta: {
        title: '规则设定'
      }
    },
    {
      path: '/main/oneCard/access/oneCardBill',
      name: 'OneCardBill',
      component: resolve =>
        require(['@/views/oneCard/access/oneCardBill'], resolve),
      meta: {
        title: '记录查询'
      }
    },
    {
      path: '/main/oneCard/attendance/base',
      name: 'AttendanceBase',
      component: resolve =>
        require(['@/views/oneCard/attendance/base'], resolve),
      meta: {
        title: '基础资料'
      }
    },
    {
      path: '/main/oneCard/attendance/rule',
      name: 'AttendanceRule',
      component: resolve =>
        require(['@/views/oneCard/attendance/rule'], resolve),
      meta: {
        title: '班次管理'
      }
    },
    {
      path: '/main/oneCard/attendance/additional',
      name: 'Additional',
      component: resolve =>
        require(['@/views/oneCard/attendance/additional'], resolve),
      meta: {
        title: '信息补录'
      }
    },
    {
      path: '/main/oneCard/attendance/report',
      name: 'Report',
      component: resolve =>
        require(['@/views/oneCard/attendance/report'], resolve),
      meta: {
        title: '报表汇总'
      }
    },
    {
      path: '/main/oneCard/consume/base',
      name: 'Base',
      component: resolve =>
        require(['@/views/oneCard/consume/base'], resolve),
      meta: {
        title: '基础管理'
      }
    },
    {
      path: '/main/oneCard/consume/allowance',
      name: 'Allowance',
      component: resolve =>
        require(['@/views/oneCard/consume/allowance'], resolve),
      meta: {
        title: '补助管理'
      }
    },
    {
      path: '/main/oneCard/consume/report',
      name: 'ConsumeReport',
      component: resolve =>
        require(['@/views/oneCard/consume/report'], resolve),
      meta: {
        title: '报表汇总'
      }
    }
  ]
}]

export const notFound = {
  path: '*',
  name: 'NotFound',
  component: resolve => require(['@/components/NotFound'], resolve),
  meta: {
    title: '404 not found',
    isMenu: false
  }
}

const router = new Router({
  mode: 'history',
  routes: baseRoutes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'UserSetting' && to.params.userId === 'add') {
    to.meta.title = '添加用户'
  }
  if (to.path === '/' && store.state.user.token) {
    return next('/main')
  }
  if (!to.meta.noAuth) {
    // 如果需要拦截
    if (store.state.user.token) {
      next()
    } else {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js